import React, { useState, useRef, useEffect } from 'react';
import  { useNavigate } from 'react-router-dom'
import { connect } from 'react-redux';
import iconEdit from '../images/step3/ic_edit.svg'
import iconModalThumbFile from '../images/modal/ic_thumb_file.svg'
import moment from 'moment'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import ProgressWaiting from '../components/progress-wating.js'
import ContactRefNo from './ContactRefNo'
import ModalAlertError from '../components/ModalAlertError'
import { api } from '../utils/endpoint.js'


import iconClaim from '../images/step2/ic_claim.svg'
import iconQuotation from '../images/step2/ic_quotation.svg'
import iconIDCard from '../images/step2/ic_id_card.svg'
import iconPicOfDamage from '../images/step2/ic_pic_of_damage.svg'
import iconVehicleRegister from '../images/step2/ic_vehical_register.svg'
import iconIDCardAuthorized from '../images/step2/ic_id_card_authorized.svg'
import iconPowerOfAttorney from '../images/step2/ic_power_of_attorney.svg'
import iconAct from '../images/step2/ic_act.svg'
import iconInsurancePolicy from '../images/step2/ic_insurance_policy.svg'
import iconRecipet from '../images/step2/ic_reciept.svg'
import iconCarDump from '../images/step2/ic_car_dump.svg'
import iconDoc from '../images/step2/ic_doc.svg'
import iconWarningAlert from '../images/alert/ic_warning.svg'
import iconCloseAlert from '../images/alert/ic_close.svg'

import iconIDCardParty from '../images/step2/ic_id_card_party.svg'
import iconRegistrationCertificate from '../images/step2/ic_registration_certificate.svg'

import { CONTACT_TYPE, TITLE_CODE} from '../utils/contact-type'
import { CAR_TYPE } from '../utils/car-type'
import { CLAIM_TYPE } from '../utils/claim-type'

import { convertEngDateToThai } from '../utils/convert-date-to-thai'
import { getTitles } from '../services/fetchTitles';



function Step3(props) {

  const navigate = useNavigate();
  const MySwal = withReactContent(Swal)

  const [ isShowAlert, setIsShowAlert ] = useState(false)
  const [ alertText, setAlertText ] = useState('')

  let onConfirm = props.onConfirm
  let onEditStep1 = props.onEditStep1
  let onEditStep2 = props.onEditStep2
  
  //รถประกัน หรือ คู่กรณี
  const [ suffererType, setSuffererType ] = useState(props.lisence_info.sufferer_type)

  //ชื่อ นามสกุล
  const [ customerName, setCustomerName ] = useState( props.contact_info.name )
  //ชื่อ อู่ศูนย์
  const [ garageName, setGarageName ] = useState(  props.contact_info.garage_name  )
  //เบอร์
  const [ customerTel, setCustomerTel ] = useState(  props.contact_info.tel  )
  //Email
  const [ customerEmail, setCustomerEmail ] = useState(  props.contact_info.email  )
  //Line
  const [ customerLine, setCustomerLine ] = useState(  props.contact_info.line_id  )

  //ประเภทผู้มาติดต่อ
  const [ contactType, setContactType ] = useState(  props.contact_info.contact_type  )
  //ผู้รับมอบอำนาจ
  const [ isAttorney, setIsAttorney ] = useState(  props.contact_info.is_attorney  )
  //ติดต่อในนามนิติ
  const [ isCompany, setIsCompany ] = useState(  props.contact_info.is_company  )

  const [ isContactTitleCode, setIsContactTitleCode ] = useState(  props.contact_info.contact_title_code )

  const [ documentType, setDocuentType ] = useState(props.claim_info.type) 

  const [ isShowLoading, setIsShowLoading ] = useState(false)

  const [ fileList, setFileList ] = useState([])

  const [ isShowAlertError, setIsShowAlertError ] = useState(false)
  const [ alertTitle, setAlertTitle ] = useState('')
  const [ alertMessage, setAlertMessage ] = useState('')

  const [ contactTypeDisplayClass, setContactTypeDisplayClass ] = useState(  props.contact_info.contact_type === 2 ? 'md:w-1/4 mt-4 md:mt-6':'md:w-1/3 mt-4 md:mt-6' )
  
  const [ documents, setDocuments ] = useState(
    [
      {
        id : 1,
        name : "ใบเคลม",
        description : "หรือ ต้นฉบับหลักฐานรับผิดชอบความเสียหายรถประกัน",
        icon : iconClaim,
        is_required : true,
        is_signatured : false
      },
      {
        id : 2,
        name : "ใบเสนอราคา",
        description : "หรือคุณสามารถใช้ใบเสร็จแทนได้",
        icon : iconQuotation,
        is_required : true,
        is_signatured : false
      },
      {
        id : 3,
        name : "รูปภาพความเสียหาย",
        description : "กรุณาแสดงภาพความเสียหายรวมถึงส่วนที่เกี่ยวข้อง",
        icon : iconPicOfDamage,
        is_required : true,
        is_signatured : false
      },
      {
        id : 4,
        name : "สำเนาบัตรประชาชนคู่กรณี",
        description : "",
        icon : iconIDCardParty,
        is_required : true,
        is_signatured : true
      },
      {
        id : 5,
        name : "สำเนาบัตรประชาชนผู้เอาประกันภัย",
        description : "",
        icon : iconIDCard,
        is_required : true,
        is_signatured : true
      },
      {
        id : 6,
        name : "หนังสือมอบอำนาจ",
        description : "พร้อมสำเนาบัตรประชาชนและติดอากรสแตมป์ 30 บาท",
        icon : iconPowerOfAttorney,
        is_required : true,
        is_signatured : false
      },
      {
        id : 7,
        name : "สำเนาบัตรประชาชนผู้มอบอำนาจ",
        description : "",
        icon : iconIDCardAuthorized,
        is_required : true,
        is_signatured : true
      },
      {
        id : 8,
        name : "สำเนาหนังสือรับรองการจดทะเบียน",
        description : "พร้อมสำเนาบัตรประชาชนกรรมการ",
        icon : iconRegistrationCertificate,
        is_required : true,
        is_signatured : true
      },
      {
        id : 9,
        name : "ต้นฉบับคู่มือจดทะเบียนรถ",
        description : "หรือสำเนา และรายการจดทะเบียนเปลี่ยนแปลง และรายการต่อภาษีปีปัจจุบัน",
        icon : iconVehicleRegister,
        is_required : false,
        is_signatured : true
      },
      {
        id : 10,
        name : "สำเนากรมธรรม์ พรบ.",
        description : "",
        icon : iconAct,
        is_required : false,
        is_signatured : false
      },
      {
        id : 11,
        name : "สำเนากรมธรรม์ประกันภัย ภาคสมัครใจ",
        description : "",
        icon : iconInsurancePolicy,
        is_required : false,
        is_signatured : false
      },
      {
        id : 12,
        name : "ต้นฉบับใบเสร็จรับเงิน",
        description : "หรือ บิลเงินสดค่ารถยก",
        icon : iconRecipet,
        is_required : true,
        is_signatured : false
      },
      {
        id : 13,
        name : "ภาพถ่ายขณะยกรถ",
        description : "กรุณาแสดงภาพขณะยกรถ รวมถึงส่วนที่เกี่ยวข้อง",
        icon : iconCarDump,
        is_required : true,
        is_signatured : false
      },
      {
        id : 14,
        name : "เอกสารเรียกร้องค่าขาดประโยชน์",
        description : "",
        icon : iconDoc,
        is_required : true,
        is_signatured : false
      },
      {
        id : 15,
        name : "ใบเคลม",
        description : "หรือ สำเนาหลักฐานรับผิดชอบความเสียหายรถคู่กรณี",
        icon : iconClaim,
        is_required : true,
        is_signatured : false
      },
      {
        id : 16,
        name : "ใบเคลม",
        description : "หรือ ต้นฉบับหลักฐานรับผิดชอบความเสียหายรถคู่กรณี",
        icon : iconClaim,
        is_required : true,
        is_signatured : false
      },
      {
        id : 17,
        name : "ใบเสนอราคา",
        description : "",
        icon : iconQuotation,
        is_required : true,
        is_signatured : false
      },
      {
        id : 18,
        name : "ต้นฉบับใบเสร็จค่ารถยก",
        description : "หรือ บิลเงินสดค่ารถยก",
        icon : iconRecipet,
        is_required : true,
        is_signatured : false
      },
      {
        id : 19,
        name : "ใบเสนอราคา",
        description : "ต้นฉบับใบเสร็จค่ารถยก หรือ บิลเงินสดค่ารถยก​",
        icon : iconQuotation,
        is_required : true,
        is_signatured : false
      },
      {
        id : 20,
        name : "ภาพถ่ายความเสียหาย",
        description : "กรุณาแสดงภาพความเสียหายรวมถึงส่วนที่เกี่ยวข้อง",
        icon : iconPicOfDamage,
        is_required : true,
        is_signatured : false
      },
      {
        id : 21,
        name : "ใบเคลม",
        description : "หรือ สำเนาหลักฐานรับผิดชอบความเสียหายรถประกัน",
        icon : iconClaim,
        is_required : true,
        is_signatured : false
      },
    ]
  )

  const [ arrayTitles, setArrayTitles ] = useState([])

  useEffect(() => {
    const fetchData = async () => {
      const {arrayTitles, listTitles } = await getTitles()
      setArrayTitles(arrayTitles)
    }
    fetchData()

  },[])

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [  ])

  function gotoSummaryPage(referenceNo, linkDoc){
    onConfirm(referenceNo, linkDoc)
  }

  useEffect(() => {
    const items = getFileList()
    setFileList(items)
  }, [ documentType ])


  // function getFileList(){
  //   let docs = []

  //   docs.push( documents[0] )
  //   docs.push( documents[1] )
  //   docs.push( documents[2] )
  //   if(suffererType === 1){
  //     docs.push( documents[3] )
  //   }
  //   if((suffererType === 0 || (suffererType === 0 && contactType === "2" ) )){
  //     docs.push( documents[4] )
  //   }
  //   if (isAttorney === true || contactType === "2"  || (suffererType === 0 && contactType === "2" )){
  //     docs.push( documents[5] )
  //   }
  //   if(isAttorney === true  || contactType === "2" || (suffererType === 0 && contactType === "2" )){
  //     docs.push( documents[6] )
  //   }
  //   if(isCompany === true){
  //     docs.push( documents[7] )
  //   }
  //   docs.push( documents[8] )
  //   if(suffererType === 1){
  //     docs.push( documents[9] )
  //   }
  //   if(suffererType === 1){
  //     docs.push( documents[10] )
  //   }

  //   return docs;
  // }

  const [ isShowLaborCost, setIsShowLaborCost ] = useState(false)
  const [ isShowAutoParts, setIsShowAutoParts ] = useState(false)
  const [ isShowLossOfBenefit, setIsShowLossOfBenefit ] = useState(false)
  const [ isShowTowCar, setIsShowTowCar ] = useState(false)

  const [ laborCost, setLaborCost ] = useState(props.contact_info.labor_cost) //ค่าแรง
  const [ autoParts, setAutoParts ] = useState(props.contact_info.auto_parts) //ค่าอะไหล่
  const [ lossOfBenefit, setLossOfBenefit ] = useState(props.contact_info.loss_of_benefit) //ค่าขาดผลประโยชน์
  const [ towCar, setTowCar ] = useState(props.contact_info.tow_car) //ค่ารถยก
  const [ totalCost, setTotalCost ] = useState(props.contact_info.labor_cost + props.contact_info.auto_parts + props.contact_info.loss_of_benefit + props.contact_info.tow_car) //รวมทั้งหมด

  function getFileList(){
    let docs = []
    // รถประกัน
    if (suffererType == '0') {
      if(documentType == "1") {
        // ค่าแรง ค่าอะไหล่ 
        docs.push( documents[0] )
        docs.push( documents[16] )
        docs.push( documents[2] )
        docs.push( documents[4] )
        if (isCompany == true) {
          // นิติบุคคล
          docs.push( documents[7] )
          
        }
        if (isAttorney === true) {
          // ผู้รับมอบอำนาจ
          docs.push( documents[5] )
          docs.push( documents[6] )
        }
        docs.push( documents[8] )

        setIsShowLaborCost(true)
        setIsShowAutoParts(true)
      } else if (documentType == "5") {
        // ค่าซ่อม ค่าแรง ค่าอะไหล่ 
        docs.push( documents[0] )
        docs.push( documents[16] )
        docs.push( documents[11] )
        docs.push( documents[2] )
        docs.push( documents[4] )
        if (isCompany == true) {
          // นิติบุคคล
          docs.push( documents[7] )
        }
        if (isAttorney === true) {
          // ผู้รับมอบอำนาจ
          docs.push( documents[5] )
          docs.push( documents[6] )
        }
        docs.push( documents[8] )

        setIsShowLaborCost(true)
        setIsShowAutoParts(true)
        setIsShowTowCar(true)
      } else if (documentType == "2") {
        // ค่ารถยก
        docs.push( documents[20] )
        docs.push( documents[16] )
        docs.push( documents[12] )
        docs.push( documents[4] )
        if (isCompany == true) {
          // นิติบุคคล
          docs.push( documents[7] )
        }
        if (isAttorney === true) {
          // ผู้รับมอบอำนาจ
          docs.push( documents[5] )
          docs.push( documents[6] )
        }
        docs.push( documents[8] )
        setIsShowTowCar(true)
      } else if (documentType == "3") {
        // ค่ายาง ค่าล้อแใ็ก
        docs.push( documents[0] )
        docs.push( documents[16] )
        docs.push( documents[2] )
        docs.push( documents[4] )
        if (isCompany == true) {
          // นิติบุคคล
          docs.push( documents[7] )
        }
        if (isAttorney === true) {
          // ผู้รับมอบอำนาจ
          docs.push( documents[5] )
          docs.push( documents[6] )
        }
        docs.push( documents[8] )

         setIsShowLaborCost(true)
         setIsShowAutoParts(true)
      } else if (documentType == "4") {
        // ค่ากระจก ค่าฟิล์ม
        docs.push( documents[0] )
        docs.push( documents[16] )
        docs.push( documents[2] )
        docs.push( documents[4] )
        if (isCompany == true) {
          // นิติบุคคล
          docs.push( documents[7] )
        }
        if (isAttorney === true) {
          // ผู้รับมอบอำนาจ
          docs.push( documents[5] )
          docs.push( documents[6] )
        }
        docs.push( documents[8] )

         setIsShowLaborCost(true)
         setIsShowAutoParts(true)
      } 
    } else {
      if(documentType == "6") {
        // ค่าแรง ค่าอะไหล่ 
        docs.push( documents[15] )
        docs.push( documents[1] )
        docs.push( documents[19] )
        documents[8].is_required = true
        docs.push( documents[8] )
        docs.push( documents[3] )
        if (isCompany == true) {
          // นิติบุคคล
          docs.push( documents[7] )
        }
        if (isAttorney === true) {
          // ผู้รับมอบอำนาจ
          docs.push( documents[5] )
          docs.push( documents[6] )
        }
        docs.push( documents[9] )
        docs.push( documents[10] )

         setIsShowLaborCost(true)
         setIsShowAutoParts(true)
      }
      else if(documentType == "7") {
        // ค่าแรง ค่าอะไหล่ ค่าขาดประโยชน์
        docs.push( documents[15] )
        docs.push( documents[1] )
        docs.push( documents[19] )
        documents[8].is_required = true
        docs.push( documents[8] )
        docs.push( documents[3] )
        if (isCompany == true) {
          // นิติบุคคล
          docs.push( documents[7] )
        }
        if (isAttorney === true) {
          // ผู้รับมอบอำนาจ
          docs.push( documents[5] )
          docs.push( documents[6] )
        }
        docs.push( documents[9] )
        docs.push( documents[10] )

         setIsShowLaborCost(true)
         setIsShowAutoParts(true)
         setIsShowLossOfBenefit(true)
      }
      else if(documentType == "8") {
        // ค่าแรง ค่าอะไหล่ ค่าขาดประโยชน์ ค่ารถยก
        docs.push( documents[15] )
        docs.push( documents[1] )
        docs.push( documents[17] )
        docs.push( documents[19] )
        documents[8].is_required = true
        docs.push( documents[8] )
        docs.push( documents[3] )
        if (isCompany == true) {
          // นิติบุคคล
          docs.push( documents[7] )
        }
        if (isAttorney === true) {
          // ผู้รับมอบอำนาจ
          docs.push( documents[5] )
          docs.push( documents[6] )
        }
        docs.push( documents[9] )
        docs.push( documents[10] )

         setIsShowLaborCost(true)
         setIsShowAutoParts(true)
         setIsShowLossOfBenefit(true)
         setIsShowTowCar(true)
      }
      else if(documentType == "9") {
        // ค่าขาดประโยชน์
        docs.push( documents[14] )
        docs.push( documents[13] )
        documents[8].is_required = true
        docs.push( documents[8] )
        docs.push( documents[3] )
        if (isCompany == true) {
          // นิติบุคคล
          docs.push( documents[7] )
        }
        if (isAttorney === true) {
          // ผู้รับมอบอำนาจ
          docs.push( documents[5] )
          docs.push( documents[6] )
        }
        docs.push( documents[9] )
        docs.push( documents[10] )

         setIsShowLossOfBenefit(true)
      }
      else if(documentType == "10") {
        // ค่าขาดประโยชน์ ค่ารถยก
        docs.push( documents[14] )
        docs.push( documents[13] )
        docs.push( documents[18] )
        documents[8].is_required = true
        docs.push( documents[8] )
        docs.push( documents[3] )
        if (isCompany == true) {
          // นิติบุคคล
          docs.push( documents[7] )
        }
        if (isAttorney === true) {
          // ผู้รับมอบอำนาจ
          docs.push( documents[5] )
          docs.push( documents[6] )
        }
        docs.push( documents[9] )
        docs.push( documents[10] )

         setIsShowLossOfBenefit(true)
         setIsShowTowCar(true)
      }
      else if(documentType == "11") {
        // ค่ารถยก
        docs.push( documents[14] )
        documents[8].is_required = true
        docs.push( documents[18] )
        docs.push( documents[8] )
        docs.push( documents[3] )
        if (isCompany == true) {
          // นิติบุคคล
          docs.push( documents[7] )
        }
        if (isAttorney === true) {
          // ผู้รับมอบอำนาจ
          docs.push( documents[5] )
          docs.push( documents[6] )
        }
        docs.push( documents[9] )
        docs.push( documents[10] )

         setIsShowTowCar(true)
      }
      else if(documentType == "13") {
        // ค่ายาง ค่าล้อแม็ก
        docs.push( documents[15] )
        docs.push( documents[1] )
        documents[8].is_required = true
        docs.push( documents[8] )
        docs.push( documents[3] )
        if (isCompany == true) {
          // นิติบุคคล
          docs.push( documents[7] )
        }
        if (isAttorney === true) {
          // ผู้รับมอบอำนาจ
          docs.push( documents[5] )
          docs.push( documents[6] )
        }
        docs.push( documents[9] )
        docs.push( documents[10] )

         setIsShowLaborCost(true)
         setIsShowAutoParts(true)
      }
      else if(documentType == "12") {
        // ค่ากระจก ค่าฟิล์ม
        docs.push( documents[15] )
        docs.push( documents[1] )
        documents[8].is_required = true
        docs.push( documents[8] )
        docs.push( documents[3] )
        if (isCompany == true) {
          // นิติบุคคล
          docs.push( documents[7] )
        }
        if (isAttorney === true) {
          // ผู้รับมอบอำนาจ
          docs.push( documents[5] )
          docs.push( documents[6] )
        }
        docs.push( documents[9] )
        docs.push( documents[10] )

         setIsShowLaborCost(true)
         setIsShowAutoParts(true)
      }
     
    }
    return docs;
  }


  function getFileListFirst( docType ){
    switch(docType){
      case 1: return props.claim_info.docs.code_1.items;
      case 2: return props.claim_info.docs.code_2.items;
      case 3: return props.claim_info.docs.code_3.items;
      case 4: return props.claim_info.docs.code_4.items;
      case 5: return props.claim_info.docs.code_5.items;
      case 6: return props.claim_info.docs.code_6.items;
      case 7: return props.claim_info.docs.code_7.items;
      case 8: return props.claim_info.docs.code_8.items;
      case 9: return props.claim_info.docs.code_9.items;
      case 10: return props.claim_info.docs.code_10.items;
      case 11: return props.claim_info.docs.code_11.items;
      case 12: return props.claim_info.docs.code_12.items;
      case 13: return props.claim_info.docs.code_13.items;
      case 14: return props.claim_info.docs.code_14.items;
      case 15: return props.claim_info.docs.code_15.items;
      case 16: return props.claim_info.docs.code_16.items;
      case 17: return props.claim_info.docs.code_17.items;
      case 18: return props.claim_info.docs.code_18.items;
      case 19: return props.claim_info.docs.code_19.items;
      case 20: return props.claim_info.docs.code_20.items;
      case 21: return props.claim_info.docs.code_21.items;
      default:  return [];
    }
  }


  function showConfirm(  ){

    Swal.fire({
      title: '<div data-testid="popup-title-text" >ยืนยันการส่งเอกสาร</div>',
      html: '<div data-testid="popup-description-text" class="swal-content-message">คุณได้ยื่นเอกสารเรียกร้องค่าสินไหมทดแทน เลขรับแจ้ง '+(props.notify_no)+'</div>',
      showCancelButton: true,
      confirmButtonColor: '#009640',
      confirmButtonText: '<span data-testid="confirm-button" class="">ยืนยัน</span>',
      cancelButtonText: '<span data-testid="cancel-button" class="">ยกเลิก</span>',
      cancelButtonColor: '#FFFFF',
      customClass: {
        popup:  'swal-content-step3 swal-contrainner-step3',
        content : 'swal-content-step3',
        icon: 'swal-warning-icon-content',
        title: 'swal-warning-title-step3',
        confirmButton: 'swal-success-confirm-step3',
        cancelButton: 'swal-warning-cancel-step3',
        actions: 'swal-warning-action-step3'
      }

    }).then((result) => {
      if (result.isConfirmed) {
        callApiConfirmContactInfo()
      }
    })
  }



  async function callApiConfirmContactInfo() {
    if (isShowLoading == false ){
      setIsShowLoading(true)
      fetch(api.nonemcs.confirm(`claim_id=${props.claim_id}`))
      .then( async (response) => {
        if(response.ok){
          return response.json();         
        }
  
        throw ({status:response.status, body: await response.json()});
      }).then(data => onSuccessCallApiConfirmContactInfo(data), (error) => {
        if (error) {
          onErrorCallApiConfirmContactInfo(error)
        }
      }).catch((error) => {
        onErrorCallApiConfirmContactInfo(error)
        setIsShowLoading(false)
      })

    }
  }
  

  function onSuccessCallApiConfirmContactInfo(data){
    setIsShowLoading(false)
    if (data && data?.statusCode >= 400) {
      onErrorCallApiConfirmContactInfo({status:500,body:{message:"เกิดข้อผิดพลาด กรุณาติดต่อฝ่ายลูกค้าสัมพันธ์ โทร. 1231 กด 4",statusCode:500}})
    } else {
      gotoSummaryPage(data.transactionId, data.path_ref_doc)
    }
  }

  function onErrorCallApiConfirmContactInfo(data){
    if (data && data?.status >= 400) {
      const statusCode = data.status.toString()
      if(statusCode[0] == '4'){
        switch (data.status) {
          case 400:
            setAlertText(data.body.message)
            showAlert()
            break;
          case 404:
            setAlertText(data.body.message)
            showAlert()
            break;
          default:
            setAlertText('เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง')
            showAlert()
        }
      } else if(statusCode[0] == '5'){
        setAlertTitle(data.body.message)
        setIsShowAlertError(true)
      }
    }else{
      setAlertTitle("เกิดข้อผิดพลาด กรุณาติดต่อฝ่ายลูกค้าสัมพันธ์ โทร. 1231 กด 4")
      setIsShowAlertError(true)
    }

    
    setIsShowLoading(false)
  }

  const getPreviewImage = (path) => {

    const image = path
    if (
      image.toString().toLowerCase().indexOf('.png') >= 0 ||
      image.toString().toLowerCase().indexOf('.jpg') >= 0 ||
      image.toString().toLowerCase().indexOf('.heic') >= 0  ||
      image.toString().toLowerCase().indexOf('.heif') >= 0 
    ) {
      return image
    }
    return iconModalThumbFile

  }

  const getContactType = (isCompany, isAttorney) => {
    let result = ''
    if (isAttorney == true) {
      result += 'ผู้รับมอบอำนาจ'
    }

    if (isCompany == true) {
      if (result.length > 0) {
        result += ' / '
      }
      result += 'นิติบุคคล'
    }

    if (result.length > 0) {
      return result
    }

    return '-'
  }

  const getDescType = (contactType) => {

    return CONTACT_TYPE(contactType + '')
  
  }

  const confirmClickError = () => {
    setIsShowAlertError(false)
  }


  const timer = useRef(null);
  const [ counter, setCounter ] = useState(1);
  function showAlert(){
    clearIntervalAlert()
    setIsShowAlert(true)
    setCounter(1)
    setAlertTimer()
  }
  function closeAlert(){
    clearIntervalAlert()
 
  }
  function setAlertTimer(){
    timer.current = setInterval(() => {
      setCounter((v) => v + 1)
    }, 1000);
    return () => clearTimeout(timer.current);
  }
  useEffect(() => {
    if (counter >= 5){
      clearIntervalAlert()
    }
  }, [counter]);

  function clearIntervalAlert(){
    clearInterval(timer.current);
    setIsShowAlert(false);
    setCounter(1)
  }

  return (
    <div className=' flex-wrap w-full '>

          <div className={((isShowAlert)? ' fixed ' : ' hidden ' )+ 'bg-[#252525]  text-white  top-[9%]  flex inset-x-0 mx-auto shadow-alert  w-fit h-[40px] py-[10px] px-[12px] mb-[40px] rounded-lg z-30'}>
            <img src={iconWarningAlert} alt="icon-warning-alert" className='w-[16px] h-[16px] mr-[8px] my-auto' />
            <span className='text-sm not-italic font-normal  my-auto' >{alertText}</span>
            <button onClick={(e) => { closeAlert() }}><img src={iconCloseAlert} alt="icon-close-alert " className='w-[16px] h-[16px] ml-[8px] my-auto' /></button>
          </div>
      
          <div className="flex flex-wrap w-full justify-center p-0  ">

              <div className='flex flex-wrap w-[1092px] px-4 md:p-20 '>


                <div className=" flex flex-wrap w-full pt-6 md:pt-0">

                    <div className='flex-wrap w-full'>
                      <ContactRefNo></ContactRefNo>
                      <span data-testid='pageTitle-label' className='flex w-full text-xl  md:text-2xl font-medium'>ยืนยันข้อมูล</span>
                      <span className='flex w-full mt-2 text-sm  text-grey-600'>กรุณาตรวจสอบข้อมูลต่างๆที่คุณได้ทำการแจ้งเข้ามาเรียกค่าสินไหมทดแทน กับทางไทยวิวัฒน์ หากตรวจสอบข้อมูลเรียบร้อยแล้ว กดปุ่ม “ยืนยันส่งข้อมูล”</span>
                    </div>


                    <div className='flex w-full mt-6 md:mt-12'>
                      <div className='grow w-full'>
                        <span data-testid='pageTitle-label' className='flex w-full text-lg md:text-2xl leading-6 md:leading-7 font-medium'>ข้อมูลผู้เรียกร้องค่าสินไหม</span>
                      </div>
                      <div data-testid='claimantInfo-edit-button' onClick={onEditStep1} className=' cursor-pointer flex-none flex my-auto'>
                        <img src={iconEdit} alt="icon-edit-info" className='w-[16px] h-16[px]' />
                        <span className='flex  text-lg md:text-base leading-6 text-green-500 ml-1'>แก้ไข</span>
                      </div>
                    </div>


                    <div className='flex flex-wrap w-full mt-4 md:mt-6 pb-6 md:pb-12 border-b border-grey-500'>
                        <div className='flex flex-wrap w-full'>
                          <div className='flex-wrap w-full md:w-1/4 mt-4'>
                            <span className='flex w-full text-sm text-grey-600'>ชื่อ-นามสกุล</span>
                            <span data-testid='contactName-text' className='flex w-full mt-1 text-base leading-5 font-medium'>{ isContactTitleCode ? arrayTitles[isContactTitleCode]+' ':'' }{ customerName }</span>
                          </div>
                        </div>

                        <div className='flex flex-wrap w-full'>
                          <div className={'flex-wrap w-full '+ contactTypeDisplayClass}>
                            <span className='flex w-full text-sm text-grey-600'>ประเภทรถ</span>
                            <span data-testid='suffererType-text' className='flex w-full mt-1 text-base leading-5 font-medium'>{ (parseInt(suffererType+'') == 0 ? 'รถประกัน' : 'รถคู่กรณี') }</span>
                          </div>
                          <div className={'flex-wrap w-full '+ contactTypeDisplayClass}>
                            <span className='flex w-full text-sm text-grey-600'>ประเภทผู้มาติดต่อ</span>
                            <span data-testid='contactType-text' className='flex w-full mt-1 text-base leading-5 font-medium'>{ getDescType(contactType) }</span>
                          </div>
                          {
                            contactType == 2 ?
                            <div className={'flex-wrap w-full '+ contactTypeDisplayClass}>
                              <span className='flex w-full text-sm text-grey-600'>ชื่อศูนย์บริการ/อู่/บริษัทรถยก</span>
                              <span data-testid='garageName-text' className='flex w-full mt-1 text-base leading-5 font-medium'>{ garageName }</span>
                            </div>
                            :
                            null
                          }
                          <div className={'flex-wrap w-full '+ contactTypeDisplayClass}>
                            <span className='flex w-full text-sm text-grey-600'>ติดต่อในนาม</span>
                            <span data-testid='on-behalfOf-text' className='flex w-full mt-1 text-base leading-5 font-medium'>{ getContactType(isCompany, isAttorney) }</span>
                          </div>
                        </div>  

                        <div className='flex flex-wrap w-full'>
                          <div className={'flex-wrap w-full '+ contactTypeDisplayClass}>
                            <span className='flex w-full text-sm text-grey-600'>เบอร์โทรศัพท์</span>
                            <span data-testid='contactNo-text' className='flex w-full mt-1 text-base leading-5 font-medium'>{ customerTel === '' ? '-' : customerTel }</span>
                          </div>
                          <div className={'flex-wrap w-full '+ contactTypeDisplayClass}>
                            <span className='flex w-full text-sm text-grey-600'>อีเมล</span>
                            <span data-testid='contactEmail-text' className='flex w-full mt-1 text-base leading-5 font-medium'>{ customerEmail === '' ? '-' : customerEmail  }</span>
                          </div>
                          <div className={'flex-wrap w-full '+ contactTypeDisplayClass}>
                            <span className='flex w-full text-sm text-grey-600'>Line ID</span>
                            <span data-testid='contactLineID-text' className='flex w-full mt-1 text-base leading-5 font-medium'>{ customerLine === '' ? '-' : customerLine  }</span>
                          </div>
                        </div>
                    </div>

                    <div className='flex w-full mt-6 md:mt-12'>
                      <div className='grow w-full'>
                        <span data-testid='pageTitle-label' className='flex w-full text-lg md:text-2xl leading-6 md:leading-7 font-medium'>รายละเอียดการเรียกร้องค่าสินไหม</span>
                      </div>
                      <div onClick={onEditStep2} className=' cursor-pointer flex-none flex my-auto'>
                        <img src={iconEdit} alt="icon-edit-info" className='w-[16px] h-16[px]' />
                        <span data-testid='claimDetails-edit-button' className='flex  text-lg md:text-base leading-6 text-green-500 ml-1'>แก้ไข</span>
                      </div>
                    </div>

                    <div className='flex flex-wrap w-full mt-6'>
                        <div className='flex flex-wrap w-full'>
                          <div className='flex-wrap w-full '>
                            <span className='flex w-full text-sm text-grey-600'>ประเภทการเรียกร้องค่าสินไหม</span>
                            <span data-testid='claimType-text' className='flex w-full mt-1 text-base leading-5 font-medium'>{CLAIM_TYPE(documentType, suffererType)}</span>
                          </div>
                        </div>
                    </div>

                    <div className='flex flex-wrap w-full mt-4 md:mt-6 bg-[#FAFAFA] rounded-t-[8px]'>
                      { isShowLaborCost ? 
                        <>
                          <div className='flex-wrap w-full w-1/2 mt-4 md:mt-6 pl-[24px]'>
                            <span className='flex w-full text-sm text-grey-600'>ค่าแรง</span>
                          </div>
                          <div className='flex-wrap w-full w-1/2 mt-4 md:mt-6'>
                            <span data-testid='price-labor-text' className='flex-none w-full text-base leading-5 font-medium pr-[24px] float-right text-right'>{new Intl.NumberFormat('th-TH', { style: 'currency', currency: 'THB' }).format(laborCost).replace(/฿/,'') } บาท</span>
                          </div>
                        </>  
                        :
                        <></>  
                      }
                      { isShowAutoParts ? 
                        <>
                          <div className='flex-wrap w-full w-1/2 pl-[24px]'>
                            <span className='flex w-full text-sm text-grey-600'>ค่าอะไหล่</span>
                          </div>
                          <div className='flex-wrap w-full w-1/2 '>
                            <span data-testid='price-autoPart-text' className='flex-none w-full text-base leading-5 font-medium pr-[24px] float-right text-right'>{new Intl.NumberFormat('th-TH', { style: 'currency', currency: 'THB' }).format(autoParts).replace(/฿/,'') } บาท</span>
                          </div>
                        </>  
                        :
                        <></>  
                      }
                      { isShowLossOfBenefit ? 
                        <>
                          <div className='flex-wrap w-full w-1/2 pl-[24px]'>
                            <span className='flex w-full text-sm text-grey-600'>ค่าขาดผลประโยชน์</span>
                          </div>
                          <div className='flex-wrap w-full w-1/2 '>
                            <span data-testid='price-loseBenefits-text' className='flex-none w-full text-base leading-5 font-medium pr-[24px] float-right text-right'>{new Intl.NumberFormat('th-TH', { style: 'currency', currency: 'THB' }).format(lossOfBenefit).replace(/฿/,'') } บาท</span>
                          </div>
                        </>  
                        :
                        <></>  
                      }
                      { isShowTowCar ? 
                        <>
                          <div className='flex-wrap w-full w-1/2 pl-[24px]'>
                            <span className='flex w-full text-sm text-grey-600'>ค่ารถยก</span>
                          </div>
                          <div className='flex-wrap w-full w-1/2 '>
                            <span data-testid='price-towCar-text' className='flex-none w-full text-base leading-5 font-medium pr-[24px] float-right text-right'>{new Intl.NumberFormat('th-TH', { style: 'currency', currency: 'THB' }).format(towCar).replace(/฿/,'') }  บาท</span>
                          </div>
                        </>  
                        :
                        <></>  
                      }

                    </div>  
                        
                    { isShowLaborCost || isShowAutoParts || isShowLossOfBenefit || isShowTowCar ? 
                      <>
                        <div className='flex flex-wrap w-full pt-3 md:pt-6 bg-[#FAFAFA] pl-[24px] pr-[24px]'>
                          <div className='flex flex-wrap w-full bg-[#FAFAFA] pl-[24px] pr-[24px] border-solid border-b-2'></div>
                        </div>
                        <div className='flex flex-wrap w-full bg-[#FAFAFA] rounded-b-[8px]'>
                          <div className='flex-wrap w-full w-1/2 mt-3 md:mt-6 pb-0 md:pb-6 pl-[24px]'>
                            <span className='flex w-full text-sm text-grey-600'>รวมทั้งหมด</span>
                          </div>
                          <div className='flex-wrap w-full w-1/2 mt-3 md:mt-6 pb-3 md:pb-6'>
                            <span data-testid='price-total-text' className='flex-none w-full text-base leading-5 font-medium pr-[24px] float-right text-right'>{new Intl.NumberFormat('th-TH', { style: 'currency', currency: 'THB' }).format(totalCost).replace(/฿/,'') } บาท</span>
                          </div>
                        </div>  
                      </> 
                      :
                      <></> 
                    }


                    <div className='flex flex-wrap w-full mt-6  border-b border-grey-500 mb-12'>
                      {
                        // getFileList().map(function(item, index){
                          fileList.map(function(item, index){
                          return (

                            <div className='flex  w-full flex-wrap'>
                              <div className='flex  w-full'>
    
                                <div className='flex-none py-6'>
                                  <span className='flex w-full text-base leading-5 font-medium'>{index+1}</span>
                                </div>
                                <div className='grow w-full pl-4'>
                                  <div className='flex-wrap  w-full py-6'>
                                    <span data-testid='docName-text' className='flex w-full text-base leading-5 font-medium'>{item.name}</span>
                                    <span data-testid='docDescription-text' className='flex w-full mt-1 text-sm text-grey-600'>{item.description}</span>
                                  </div>
                                  <div className='flex-wrap  w-full pb-6  px-4'>
                                      {
                                        getFileListFirst(item.id).map(function(item, index){
                                          return (
                                            <div data-testid='docThumbnail-image' className={((true)? ' border-b border-grey-500 ': '')+' flex w-full   py-6'}>
                                              <div className='flex'>
                                                
                        
                                                <img className='w-[40px] h-[40px]' src={getPreviewImage(item.path)} alt="icon-thumb-file" />
                                              </div>
                                              <div className='flex flex-wrap  ml-3 my-auto'>
                                                <span className='w-full text-sm'>{item.name}</span>
                                                <span className='w-full text-xs mt-[4px] text-grey-800'>{ convertEngDateToThai(moment(item.date).format('DD/MM/YYYY')) } · {Math.round(item.size/1000)} kb</span>
                                              </div>
                                            </div>
                                          )
                                        })

                                      }         
                                      
                                  
                                  </div>
                                </div>
                              </div>
                            </div>
                          )
                        })
                      }
                    </div>

 
                   

                </div>
              </div>
              <div className='flex-wrap flex w-full mt-6 md:mt-20  md:h-80px md:justify-center  bg-white border-t-[0.5px] border-grey-500 fixed bottom-0 right-0'>
                <div className='flex flex-wrap w-full md:w-[1092px] md:justify-end '>
                  <button
                      data-testid='submit-button' 
                      onClick={ (e)=>{ showConfirm() }}
                      className={'w-full m-[16px] md:w-[160px] lg:px-3 text-base leading-6 h-[48px]  md:h-12 font-medium rounded-md border-radius-other  '+ ( (false)? ' bg-grey-600 text-white ' : ' bg-green-500 text-white ')}>
                        ยืนยันส่งข้อมูล
                  </button>
                </div>
              </div>

          

          </div>
          {
            isShowLoading ?
              <ProgressWaiting />
            :
            null
          }

          {
            isShowAlertError ?

            <ModalAlertError 
              title={alertTitle}
              message={alertMessage}
              confirmClick={confirmClickError}
            />
            :
            null
          }

    </div>
  )
}


const mapStateToProps = state => {
  return state
}
const mapDispatchToProps = dispatch => {
  return {
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(Step3);